import React from "react";
import { EntityAssignModal } from "../EntityAssignModal";
import { useDrawersContext } from "../../routes/tasks/drawers-context";
import { AssignTaskDto } from "../../model/shared/dto/AssignTaskDto";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { taskActions } from "../../redux/task/task.slice";
import { taskSliceSelectors } from "../../redux/task/task.selector";
import { useFormContext } from "react-hook-form";
import { GetTasksFilterDto } from "../../model/task/dto/GetTasksFilterDto";
import { AtiraToast } from "../../utils/AtiraToast";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { appSliceSelectors } from "../../redux/app/app.selector";
import fetchAfterTaskAction from "./functions/fetchAfterTaskAction";

export const TaskAssignModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getValues: contextGetValues } = useFormContext<GetTasksFilterDto>();
  const {
    task,
    setTask,
    setEntry,
    kanbanCard,
    setKanbanCard,
    taskAssignVisible,
    setTaskAssignVisible,
  } = useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const tasksPage = useAppSelector(taskSliceSelectors.selectTasksPage);
  const tasksPageSize = useAppSelector(taskSliceSelectors.selectTasksPageSize);
  const searchOptions = useAppSelector(appSliceSelectors.selectSearchOptions);
  const floatingTodayTasksVisible = useAppSelector(
    appSliceSelectors.floatingTodayTasksVisible,
  );

  const localOnClose = () => {
    setTaskAssignVisible(false);
  };

  const onAssign = async (ids: string[]) => {
    if (!task) {
      return;
    }

    try {
      const updateDto: AssignTaskDto = {
        assigneeIds: ids,
        taskId: task._id,
        userId,
      };

      await dispatch(taskActions.assignTask(updateDto)).unwrap();

      await fetchAfterTaskAction({
        userId,
        task,
        entryId: task?.parentId!,
        taskId: task?._id,
        kanbanCardId: kanbanCard?._id,
        pathname,
        tasksPage,
        tasksPageSize,
        dispatch,
        setEntry,
        setTask,
        setKanbanCard,
        contextGetValues,
        searchKeyword: searchOptions?.keyword,
        isFloatingTodayTasksOpen: floatingTodayTasksVisible === true,
      });

      localOnClose();

      AtiraToast.success(t("tasks.assign.success"));
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);
    }
  };

  if (!task) {
    return null;
  }

  return (
    <EntityAssignModal
      isOpen={taskAssignVisible}
      onClose={localOnClose}
      onConfirm={onAssign}
      entity={task}
    />
  );
};
